goog.provide('el8.uiwidget.FeedRenderer');

goog.require('el8.template.uiwidget.Feed');
goog.require('el8.util.base');
goog.require('el8.uiwidget.FeedPage');
goog.require('el8.uiwidget.alert');


//========================================================
// Key helper class for the Feed object.
// Manages all the rendering of the actual Feed DOM elt
//========================================================
el8.uiwidget.FeedRenderer = function(spec) {

    spec = spec || {};

    /**
     * Essential for DOM scaffolding
     */
    this._container = spec.container; // required
    this._skeletonFn = spec.skeletonFn;  // required

    this._scrollContainer = spec.scrollContainer || this._container;
    this._noScroll = (spec.noScroll === true); // defaults to false // TODO NEED?
    this._infiniteScroll = spec.infiniteScroll || null; // infinite scrolling feeds

    /**
     * el8.uiwidget.FeedData object - used for figuring out what to actually render
     */
    this._feedData = spec.feedData;

    /**
     * Key inputs to the renderer -- how to render items, etc.
     */
    this._rendererFn = spec.rendererFn || function() {};
    this._renderChunkSize = spec.renderChunkSize || null;

    /** 
     * Map of model classes to the React-based render functions that should be used to render
     * feed items corresponding to those model classes. Any model classes with entries
     * in this map should still be handled by `_rendererFn` as well, but `_rendererFn` should
     * simply be responsible for rendering an empty container element that `ReactDOM` can render
     * into. **The empty container element MUST have an ID.**
     * 
     * The render function signature is:
     * ```
     * (params: { indexedItem: object; itemId: number; containerId: string; }) => void
     * ```
     * - `params.indexedItem` is the feed index item that corresponds to the data
     * - `params.itemId` is the ID of the data, e.g. a prescription ID or report ID
     * - `params.containerId` is the ID of the empty container element that `ReactDOM` should render
     * into
     * 
     * See also:
     * - `el8.template.render.reqActFeedItemNew` for an example of an empty container element
     * used by `_rendererFn` for the requiring actions feed
     * - `el8.appchart.mainFeeds.reqActReactRenderMap` for an example of a React render map
     * used by the requiring actions feed
     */
    this._reactRenderMap = spec.reactRenderMap || null;

    // Triggers events on the calling Feed
    this._triggerFn = spec.triggerFn || null;

    /**
     * Help with naming of specific items in the feed
     */
    this._name = spec.name;
    this._feedIdFn = spec.feedIdFn || function(itemId) { return this._name+'_'+itemId; };

    /**
     * Custom navigation and messages to be displayed to user
     */
    this._moreTrigger = spec.moreTrigger || null;
    this._emptyMsg = spec.emptyMsg || null;
    this._errorMsg = spec.errorMsg || 'An unexpected error has occurred.';
    this._describePageFn = spec.describePageFn || null;

    /**
     * Custom rendering functions
     */
    this._addlRenderItemFn = spec.addlRenderItemFn || null;
    this._addlRenderFn = spec.addlRenderFn || null;
    this._emptyTemplateFn = spec.emptyTemplateFn || null;

    /**
     * Custom function that runs every time right before
     * an item is re-rendered
     */
    this._addlResetItemFn = spec.addlResetItemFn || null;
    this._addlResetFn = spec.addlResetFn || null;

    /**
     * Useful classes
     */
    this._highlightClass = spec.highlightClass || 'el8FeedItemSelected';

    /**
     * Refers to the Feed that owns this renderer
     */
    this._parentFeed = spec.parentFeed || null;

    /***************
     * Holds state *
     ***************/
    this._isInit = false;
    this._needsRender = false;  // Is the rendered feed out of date with the feed data?
    this._renderedPage = new el8.uiwidget.FeedPage(); // what is currently rendered

};


//========================================================
// Initialize renderer
//========================================================
el8.uiwidget.FeedRenderer.prototype.init = function(spec) {

    spec = spec || {};

    this._isInit = true;

    var that        = this;
    var listId      = this._name+'-feed-list';
    var counterId   = this._name+'-feed-count';

    this._moreTriggerFn = spec.moreTriggerFn || null;
    this._checkMarkerFn = spec.checkMarkerFn || null;

    /**
     * Attach the DOM elements that we'd like
     */
    this._container.append(this._skeletonFn({
        counterId: counterId,
        listId: listId,
        infiniteScroll: this._infiniteScroll
    }));
    this._counter = $('#'+counterId, this._container);
    this._list = $('#'+listId, this._container);

    this.reset();

    if (spec.moreTriggerFn && this._moreTrigger && (typeof(this._moreTrigger) === 'string')) {
        if (this._infiniteScroll) {
            /**
             * Bind scrollContainer
             */
            this._scrollContainer.on('scroll', _.throttle(function () {
                that.checkAndLoadFeed($(this), that._moreTrigger);
            }, 100));
        } else {
            /**
             * Bind moreTrigger
             */
            this._container.on('click', this._moreTrigger, function(e) {
                spec.moreTriggerFn();
                return false;
            });
        }
        this._hideMoreTrigger();
    }
};


//========================================================
// Useful public methods
//========================================================
el8.uiwidget.FeedRenderer.prototype.show = function() {
    if (this.countRenderedItems()) {
        this._container.show();
    } else {
        this.renderEmpty();
    }
};
el8.uiwidget.FeedRenderer.prototype.showContainer = function() {
    this._container.show();
};
el8.uiwidget.FeedRenderer.prototype.hide = function(duration) {
    this._container.hide(duration);
};
el8.uiwidget.FeedRenderer.prototype.destroy = function(duration) {
    var that = this;
    if (duration) {
        this._container.hide(duration, function() {
            that._container.remove();
        });
    } else {
        that._container.remove();
    }
};
el8.uiwidget.FeedRenderer.prototype.markNeedsRender = function() {
    this._needsRender = true;
};
el8.uiwidget.FeedRenderer.prototype.getNeedsRender = function() {
    return this._needsRender;
};
el8.uiwidget.FeedRenderer.prototype.getRenderItem = function(itemId) {
    return $('#'+this._feedIdFn(itemId), this._list);
};
el8.uiwidget.FeedRenderer.prototype.getListElt = function() { return this._list; };
el8.uiwidget.FeedRenderer.prototype.countRenderedItems = function() {
    return this._renderedPage.getSize();
};
el8.uiwidget.FeedRenderer.prototype.isItemRendered = function(itemId) {
    var pos = this._feedData.getPositionById(itemId);
    return (pos !== undefined) ? this._renderedPage.includes(pos) : false;
};
el8.uiwidget.FeedRenderer.prototype.getFeedId = function(itemId) {
    return this._feedIdFn(itemId);
};
el8.uiwidget.FeedRenderer.prototype.isRendered = function() {
    return this._isInit && this._list && !!this._list.children().length;
};
el8.uiwidget.FeedRenderer.prototype.highlight = function(itemId) {
    /* Clear focus on all other items and add focus on an item */
    $('.'+this.highlightClass, this._list).removeClass(this._highlightClass);
    this.getRenderItem(itemId).addClass(this._highlightClass);
    return this;
};
el8.uiwidget.FeedRenderer.prototype.unhighlight = function(itemId) {
    /* Remove focus on an item */
    this.getRenderItem(itemId).removeClass(this._highlightClass);
    return this;
};
el8.uiwidget.FeedRenderer.prototype.isVisible = function(container, itemId) {
    var ctrHeight   = container.height();
    var itemTop     = $(itemId).offset().top;
    // When the feed reaches the end of the list the marker returns zero.
    if (itemTop === 0) { return false; }
    // 100px are added so the feed loads before scrolling to the bottom.
    return (itemTop - 100) <= ctrHeight;
};
el8.uiwidget.FeedRenderer.prototype.checkAndLoadFeed = function(container, itemId) {
    // Check when the marker element scrolls into view
    var result = this._checkMarkerFn(container, itemId);
    if (result) { this._moreTriggerFn(); }
    return false;
};

//========================================================
// Basic rendering
//========================================================
el8.uiwidget.FeedRenderer.prototype.appendPage = function(page, force) {

    /**
     * This method appends the given page to what is currently rendered
     */

    // Make sure container is showing
    this._container.show();

    /* If this isn't appending to the end of renderedPage, then freak out */
    if (!page.isEmpty() && (page.getStart() !== this._renderedPage.getEnd())) {
        UIM && UIM.logError('Trying to append a non-contiguous page (feed: '+this._name+', page: '+page.asStr()+')');
        return;
    }

    /* Continue drawing page */
    this._drawPageItems(page, force);
    this.updateAddlUi();

    // Pre-fetch surrounding pages of items, only in this case of appending
    this._feedData.prefetchPages(this._renderedPage);

    return (this.countRenderedItems() > 0);

};
el8.uiwidget.FeedRenderer.prototype.renderPage = function(page, force, opts) {
    opts = opts || {};

    /**
     * This method clears what is currently rendered and then renders
     * the given page
     */

    // Make sure container is showing
    this._container.show();

    // Reset first
    this.reset();
    this.displayLoading();

    // Set up this._renderedPage
    this._renderedPage.setStart(page.getStart());
    this._renderedPage.setSize(0);

    if (page.isEmpty()) {
        this.renderEmpty();
        this.updateAddlUi();
    } else {
        this._drawPageItems(page, force);
        this.updateAddlUi();
    }

    this.clearLoading();

    // rendered feed should now be in sync with feed data
    this._needsRender = false;

    // If infinite scrolling is true check if the marker is visible
    if (this._infiniteScroll) {
        this.checkAndLoadFeed(this._scrollContainer, this._moreTrigger);
    }

    return (this.countRenderedItems() > 0);

};
el8.uiwidget.FeedRenderer.prototype._drawPageItems = function(page, force) {
    /**
     * This method is a helper used for any sort of rendering of a page in the feed
     */
    if (page.isEmpty()) { return; }

    var pages = [page];
    if (this._renderChunkSize) {
        pages = page.split(this._renderChunkSize);
    }

    for (var i=0; i<pages.length; i++) {

        var currPage = pages[i];

        /**
         * Need both list of items, and indexedItems versions for rendering
         * If no fetchFn, then items will be same as indexedItems
         */
        var items = this._feedData.fetchPage(currPage, force, false); // always sync
        var indexedItems = this._feedData.getSubIndex(currPage);

        var rendered = null;
        for (var j = 0; j < indexedItems.length; j++) {
            var indexedItem = indexedItems[j];
            var itemId = indexedItem.id;
            var item;
            // Add conditional branching to run new logic only if `reactRenderMap` is specified;
            // we cannot run the new logic in all cases because `items` is not always an array of
            // el8 entities with a `getId` method. And IDs actually could live in multiple different
            // places, e.g. `item.id` vs `item.getId()` vs `item._id` - it's messy. Conditionally branching
            // how we set `item` is the simplest, lowest-risk approach since:
            // - we know the only React-rendered feed right now has items that consistently have a `getId`
            // method
            // - React-rendered feeds are the only feeds where the old approach for determining `item`
            // does not work, so for all other feeds we can safely just use the old logic in the `else`
            // block
            if (this._reactRenderMap) {
                // `items` might be smaller than `indexedItems` (and therefore we can't
                // find a given indexedItem's corresponding item by simply accessing the
                // same index on each of the two arrays) because any feed items that
                // are being fetched & rendered by React will be present in `indexedItems`
                // but NOT included in `items`. So we use `.find()` here instead.
                //
                // This means for indexed items that are to be rendered by React, the
                // `item` argument passed into `_renderItem` will be undefined. `_renderItem`
                // shouldn't need a valid `item` argument in this case because all it
                // needs to do there is to render an empty container element for React
                // to render into.
                item = items.find(function (arrayItem) {
                    return arrayItem.getId() === itemId;
                });
            } else {
                item = items[j];
            }

            rendered = $(this._renderItem(item, indexedItem));
            this._list.append(rendered);
            this._renderedPage.grow(1);

            var reactRenderFn = this._getReactRenderFn(itemId);
            if (reactRenderFn) {
                reactRenderFn({
                    containerId: rendered.attr('id'),
                    indexedItem: indexedItem,
                    itemId: itemId
                });
            }

            if (this._addlRenderItemFn) { this._addlRenderItemFn(rendered, item); }
        }
    }
};

/**
 * If the given item is to be rendered by React (i.e. `reactRenderMap` contains
 * an entry for that item's model class), this returns the React-based render
 * function for that item. Otherwise, this returns null.
 */
el8.uiwidget.FeedRenderer.prototype._getReactRenderFn = function(itemId) {
    var indexedItem = this._feedData.getIndexedItemById(itemId);
    var reactRenderFn = this._reactRenderMap && this._reactRenderMap[indexedItem.model_class];
    return reactRenderFn || null;
};

/**
 * Returns true if the given indexed item's rendering is handled by React
 * instead of legacy.
 */
el8.uiwidget.FeedRenderer.prototype._isReactRendered = function(itemId) {
    return Boolean(this._getReactRenderFn(itemId));
}

el8.uiwidget.FeedRenderer.prototype._renderItem = function(item, indexedItem) {
    return this._rendererFn(item, indexedItem)(item, this._feedIdFn(indexedItem['id']), indexedItem);
};

//========================================================
// Key public rendering methods
//========================================================
el8.uiwidget.FeedRenderer.prototype.appendNextPage = function() {
    var nextPage = this._feedData.getNextPage(this._renderedPage);
    return this.appendPage(nextPage);
};
el8.uiwidget.FeedRenderer.prototype.appendNextItems = function(num) {
    var page = new el8.uiwidget.FeedPage();
    page.mimic(this._renderedPage).forward(num, this._feedData.countItems());
    return this.appendPage(page);
};
el8.uiwidget.FeedRenderer.prototype.appendNextUntilId = function(id) {
    var nextPage = this._feedData.getNextPage(this._renderedPage, id);
    return this.appendPage(nextPage);
};
el8.uiwidget.FeedRenderer.prototype.appendAllItems = function() {
    var lastId = this._feedData.getDataIndex()[this._feedData.countItems() - 1];
    var nextPage = this._feedData.getNextPage(this._renderedPage, lastId);
    return this.appendPage(nextPage);
};
el8.uiwidget.FeedRenderer.prototype.renderPageByDate = function(d8) {
    var page = this._feedData.getPageByDate(d8);
    return this.renderPage(page);
};
el8.uiwidget.FeedRenderer.prototype.renderPageByNumber = function(num, opts) {
    var page = this._feedData.getPageByNumber(num);
    return this.renderPage(page, null, opts);
};
el8.uiwidget.FeedRenderer.prototype.refreshRender = function(force) {
    var rememberPage = new el8.uiwidget.FeedPage();
    rememberPage.mimic(this._renderedPage);
    return this.renderPage(rememberPage, force);
};


//========================================================
// Refresh following an index update. Needs to be thoughtful
// about how to re-render page
//========================================================
el8.uiwidget.FeedRenderer.prototype.refreshAfterUpdate = function(oldIndex) {
    this._smartUpdatePage(oldIndex);
    this.refreshRender();
};
el8.uiwidget.FeedRenderer.prototype._smartUpdatePage = function(oldIndex) {

    /**
     * The goal of this method is to update this._renderedPage upon loading of
     * a new index.  If we don't do this, then the feed can jump surprisingly and/or
     * make items disappear that were previously appearing.
     *
     * Priorities here, in order, are:
     * 1. if we are rendering 0th index item, must still render 0th index item
     * 2. not to remove any items that were previously showing
     * 3. to preserve size of the renderedPage, unless we were rendering whole feed,
     *    in which case we want to continue rendering whole feed
     *
     * IMPORTANT: To achieve the above, this method assumes that items in
     * the index cannot change ordering.  If items do change ordering, there may
     * be jumping to unexpected parts of the feed upon sync-refresh
     */

    var newIndex = this._feedData.getDataIndex();

    var oldIndexFirstR  = this._renderedPage.getStart();
    var oldSizeR        = this._renderedPage.getSize();
    var oldIndexLastR   = this._renderedPage.getEnd() - 1;

    /* There's a bug somewhere that lets oldIndexLastR end up larger than the whole index...
     * We don't know where it is, but we can at least mitigate it here */
    if (oldIndexLastR > oldIndex.length) {
        oldIndexLastR = oldIndex.length - 1;
    }

    /* If whole feed was shown, update rendered page to continue showing whole page */
    if ((oldIndexFirstR === 0) && (oldIndex.length <= this._renderedPage.getSize())) {
        this._renderedPage.set(0, newIndex.length);
        return;
    }

    /* Keep rendering of 0th index if it was indeed rendered */
    var newIndexFirstR = (oldIndexFirstR === 0) ? 0 :
        this._feedData.getPositionById(oldIndex[oldIndexFirstR]['id']);

    /* Try to maintain the whole range of what was previously rendered */
    var newIndexLastR = this._feedData.getPositionById(oldIndex[oldIndexLastR]['id']);

    /* Update rendered page accordingly */
    if (!el8.util.isNone(newIndexFirstR) && !el8.util.isNone(newIndexLastR)) {
        /* Render at least the same page size, with same first item and last item on page */
        this._renderedPage.set(newIndexFirstR,
            Math.max(oldSizeR, newIndexLastR+1 - newIndexFirstR));

    } else if (!el8.util.isNone(newIndexFirstR)) {
        /* Item that was originally last has been removed */
        this._renderedPage.set(newIndexFirstR, oldSizeR);

    } else if (!el8.util.isNone(newIndexLastR)) {
        /* Item that was originally first has been removed and was not 0-index item */
        this._renderedPage.set(
            Math.max(0, newIndexLastR+1 - oldSizeR), oldSizeR);
    } /* Else, if both items have been removed, keep same rendered page params */

    /* Make sure rendered page values are valid */
    if (this._renderedPage.getEnd() > newIndex.length) {
        this._renderedPage.setSize(newIndex.length - this._renderedPage.getStart());
    }

};


//========================================================
// Refresh or remove a rendered item from the feed
//========================================================
el8.uiwidget.FeedRenderer.prototype.refreshRenderItem = function(itemId, force) {

    /* Don't do anything if item isn't currently rendered */
    if (!this.isItemRendered(itemId)) { return false; }

    /* Don't do anything for React-rendered items. React handles keeping those up-to-date. */
    if (this._isReactRendered(itemId)) return false;

    /* Don't do anything if can't fetch item */
    var obj = this._feedData.fetchDataById(itemId, force);
    if (!obj) { return false; }

    /* Otherwise, refresh item in place */
    var item = obj['item'];
    var indexedItem = obj['indexedItem'];

    /* Call addlResetItemFn before re-render */
    var $oldRenderer = this.getRenderItem(indexedItem['id']);
    if (this._addlResetItemFn) { this._addlResetItemFn(item, $oldRenderer); }
    var $rendered = $(this._renderItem(item, indexedItem));
    $oldRenderer.replaceWith($rendered);
    if (this._addlRenderItemFn) { this._addlRenderItemFn($rendered, item); }

    return item;
};
el8.uiwidget.FeedRenderer.prototype.removeRenderItem = function(itemId, duration) {

    if (!this.isItemRendered(itemId)) { return false; }
    var $content = this.getRenderItem(itemId);

    this._renderedPage.shrinkByOne();

    if (this._isReactRendered(itemId)) {
        if (el8React && el8React.unmountComponent) {
            el8React.unmountComponent($content.attr('id'));
        } else {
            console.warn(
                'Tried to unmount React component for legacy feed item, but ' +
                '`el8React.unmountComponent` is not available on this page. ' +
                'Please ensure it exists so proper cleanup can be performed.'
            );
        }
    }

    /* Fetch item first and call addlResetItemFn before remove from index */
    if (this._addlResetItemFn) {
        var obj = this._feedData.fetchDataById(itemId, false);
        if (obj) { this._addlResetItemFn(obj['item'], $content); }
    }
    this._feedData.removeFromIndex(itemId);

    var that = this;
    var onRemoveFn = function() {
        if (!that.countRenderedItems()) {
            that._renderIfEmptiedPage();
        }
        that.updateAddlUi();
    };
    if (duration) {
        if ($content.length) {
            $content.fadeOut(duration, function() {
                $content.remove();
                onRemoveFn();
            });
        }
    } else {
        if ($content.length) { $content.remove(); }
        onRemoveFn();
    }

    return true;
};
el8.uiwidget.FeedRenderer.prototype._renderIfEmptiedPage = function() {
    var prevPage = this._feedData.getPrevPage(this._renderedPage);
    if (!prevPage.isEmpty()) {
        this.renderPage(prevPage);
    } else {
        var nextPage = this._feedData.getNextPage(this._renderedPage);
        if (!nextPage.isEmpty()) {
            this.renderPage(nextPage);
        } else {
            this.renderEmpty();
        }
    }
};


//========================================================
// Special case rendering
//========================================================
el8.uiwidget.FeedRenderer.prototype.reset = function() {

    /* Call addlResetItemFn on rendered items if it's there */
    if (this._addlResetItemFn) {
        var renderedItems = this._feedData.fetchPage(this._renderedPage);
        var that = this;
        renderedItems.forEach(function(item) {
            var $rendered = that.getRenderItem(item.getId());
            that._addlResetItemFn(item, $rendered);
        });
    }

    if (this._list) { this._list.empty(); }
    this._renderedPage.reset();
    this._hideMoreTrigger();

    /* Call addlResetFn as needed */
    if (this._addlResetFn) { this._addlResetFn(); }
};
el8.uiwidget.FeedRenderer.prototype.renderError = function() {
    this.reset();
    if (this._errorMsg) {
        this._container.show();
        this._list.append(el8.template.uiwidget.Feed.emptyHeader({emptyMsg: this._errorMsg}));
    } else {
        // If errorMsg is null or undefined, we hide container when error
        this._container.hide();
    }
    this._needsRender = false;
};
el8.uiwidget.FeedRenderer.prototype.renderEmpty = function() {
    this.reset();
    if (this._emptyMsg || this._emptyTemplateFn) {
        this._container.show();
        if (this._emptyTemplateFn) {
            this._list.append(this._emptyTemplateFn());
        } else {
            this._list.append(el8.template.uiwidget.Feed.emptyHeader({emptyMsg: this._emptyMsg}));
        }
    } else {
        // If emptyMsg is null or undefined, we hide container when empty
        this._container.hide();
    }
    this._needsRender = false;
};
el8.uiwidget.FeedRenderer.prototype.displayLoading = function() {
    this._container.show();
    this._list.addClass('feedLoading');
    this._hideMoreTrigger();
};
el8.uiwidget.FeedRenderer.prototype.clearLoading = function() {
    this._list.removeClass('feedLoading');
};


//========================================================
// Manage rendering of buttons and counters
//========================================================
el8.uiwidget.FeedRenderer.prototype.updateAddlUi = function() {

    if (this._triggerFn) { this._triggerFn('render'); }

    // Make sure counters and buttons are updated
    if (this._counter && this._counter.length) {
        this._counter.text(this._renderedPage.getSize());
    }

    if (this._moreTrigger) {
        if (this.isNextPageEmpty()) {
            this._hideMoreTrigger();
        } else {
            this._showMoreTrigger();
        }
    }

    if (this._addlRenderFn) { this._addlRenderFn(this); }

};
el8.uiwidget.FeedRenderer.prototype.isNextPageEmpty = function() {
    return this._feedData.getNextPage(this._renderedPage).isEmpty();
};
el8.uiwidget.FeedRenderer.prototype._showMoreTrigger = function() {
    var info = this._describePage(this._feedData.getNextPage(this._renderedPage));
    if (this._moreTrigger) {
        $(this._moreTrigger, this._container).show().html(info);  // XSS OK -KF
        $('.el8Loading', this._container).show();
    }
};
el8.uiwidget.FeedRenderer.prototype._hideMoreTrigger = function() {
    if (this._moreTrigger) {
        $(this._moreTrigger, this._container).hide();
        $('.el8Loading', this._container).hide();
    }
};
el8.uiwidget.FeedRenderer.prototype._describePage = function(page) {
    if (this._describePageFn) {
        return this._describePageFn(page, this._feedData.countItems());
    } else {
        var numItems = page.getSize();
        return el8.template.uiwidget.Feed.pageDescription({'numItems': numItems});
    }
};


//========================================================
// Manage scrolling
//========================================================
el8.uiwidget.FeedRenderer.prototype.scrollToTop = function() {
    if (!this._noScroll) {
        this._scrollContainer.scrollTo(this._container);
    }
};
el8.uiwidget.FeedRenderer.prototype.scrollToItem = function(itemId) {
    var elt = this.getRenderItem(itemId);
    if (elt.length) {
        this._scrollContainer.scrollTo(elt);
    } else {
        this._scrollContainer.scrollTo(0,0);
    }
};
